import { useAppDispatch } from 'src/hook'
import { localStoragesName } from 'src/models/enum'
import { resetDoctorData } from 'src/store/doctor'
import { logout } from 'src/store/user'

const useLogout = () => {
  const dispatch = useAppDispatch()

  const logoutHandler = () => {

    sessionStorage.clear();

    dispatch(resetDoctorData())
    dispatch(logout())
    console.clear()
  }

  return { logoutHandler }
}

export default useLogout
